// dev
// export const videoBucket = 'http://localhost:8080/uploads';
export const videoBucket = 'https://s3.us-west-1.amazonaws.com/paragchordia.com';